__webpack_require__.p = "https://chat.v2-uat.thuocsi.vn/_next/";